/** First-party cookie holding a coupon code the shopper clicked but that could not be
 *  redeemed yet (empty cart). Same trust level as the cart session cookie itself — not a
 *  third-party tracking cookie, so browser cookie restrictions don't apply. */
export const PENDING_PROMO_CODE_COOKIE = 'vr_promo';

/** 30 days. Long enough to survive an emailed campaign landing, short enough that a code
 *  from a finished promotion doesn't linger and fail confusingly months later. */
export const PENDING_PROMO_CODE_TTL_DAYS = 30;

/** Contentful authors write a normal hyperlink to `/apply-coupon/SPRING20`; the rich-text
 *  renderer turns any link matching this into a coupon-applying control. */
export const APPLY_COUPON_PATH_PREFIX = '/apply-coupon/';
